const marketing = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryRemainderOverview({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/overview", params);
      return data;
    },
    async queryRechargeItemList({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/queryRechargeItemList", params);
      return data;
    },
    async createRechargeOrder({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/createRechargeOrder", params);
      return data;
    },
    async queryRechargeSuccessful({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/isRechargeSuccessful", params);
      return data;
    }
  }
};

export default marketing;



// WEBPACK FOOTER //
// ./src/store/modules/marketing.js